// CONTATOS À DIREITA NO TOPO CENTRAL (modelo_topo = 5) — cs2641 Due Imóveis.
//
// Por padrão a faixa fina do topo 5 mostra os telefones do cadastro (tel1/tel2) no canto
// ESQUERDO e as redes sociais no direito. 21/09 a Due pediu, só para o site dela: tirar o
// número da esquerda e mostrar no canto DIREITO os WhatsApps das duas sócias, cada um com
// o nome e o ícone do WhatsApp à esquerda do número, com as redes sociais logo ao lado
// (as redes seguem vindo do cadastro: quando preencherem, os ícones aparecem sozinhos).
//
// Os números ficam aqui, e não no cadastro, porque o cadastro tem um único telefone (a Taís)
// e ele também alimenta o botão flutuante, a ficha e o rodapé — o pedido é só para o topo.
//
// Allowlist e não regra geral: nos demais tenants em modelo_topo 5 a faixa segue igual.
export type ContatoTopoCentral = { tel: string; nome: string };

export const TOPO_CENTRAL_CONTATOS_DIREITA: Record<number, ContatoTopoCentral[]> = {
  2641: [
    { tel: '51981788298', nome: 'Abelle' },
    { tel: '51992999669', nome: 'Taís' },
  ],
};

/** Contatos fixos do canto direito da faixa do topo 5; null = tenant fora da lista (faixa padrão). */
export function contatosTopoCentralDireita(site: any): ContatoTopoCentral[] | null {
  return TOPO_CENTRAL_CONTATOS_DIREITA[Number(site?.id)] ?? null;
}
